import React from 'react';
import PropTypes from 'prop-types';
import Hidden from '@material-ui/core/Hidden';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  bottomNav: {
      display: 'flex',
      justifyContent: 'center',
  },
  bottomNavLinks: {
      display: 'flex',
      justifyContent: 'space-between',
      flexGrow: 1,
      margin: '1rem 5rem'
  },
  bottomNavLink: {
      color: theme.palette.text.primary,
      textDecoration: 'none',
      '&:hover': {
          color: theme.palette.text.primary,
      }
  }, 
  copyright: {
    color: theme.palette.text.primary,
    margin: '1rem .5rem',
    textAlign: 'center'
  }
});

class BottomNav extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.bottomNav}>
        <div className={classes.copyright}>© 1971 — 2019 DirectBuy. All Rights Reserved</div>
      </div>
    );
  }
}

BottomNav.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BottomNav);
